export const INCREMENT_BET_VALUE = 'INCREMENT_BET_VALUE';
export const DECREMENT_BET_VALUE = 'DECREMENT_BET_VALUE';
export const UNDO_LAST_BET_ACTION = 'UNDO_LAST_BET_ACTION';
export const REMOVE_OPEN_BET = 'REMOVE_OPEN_BET';
export const REMOVE_ALL_BETS = 'REMOVE_ALL_BETS';

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';

export const OPEN_CLOSE_BET_HISTORY = 'OPEN_CLOSE_BET_HISTORY';
export const SELECT_BET_HISTORY_TAB = 'SELECT_BET_HISTORY_TAB';
export const SELECT_BET_HISTORY_GAME = 'SELECT_BET_HISTORY_GAME';
export const TOGGLE_BET_HISTORY_FILTER_WINS = 'TOGGLE_BET_HISTORY_FILTER_WINS';

export const SET_FULL_SCREEN_MODE = 'SET_FULL_SCREEN_MODE';
export const SET_ATTRACTS_VISIBILITY = 'SET_ATTRACTS_VISIBILITY';

export const TOGGLE_COMMIT_BETS_SUCCESS = 'TOGGLE_COMMIT_BETS_SUCCESS';
export const TOGGLE_COMMIT_BETS_ERROR = 'TOGGLE_COMMIT_BETS_ERROR';
export const TOGGLE_COMMITTING_BETS = 'TOGGLE_COMMITTING_BETS';
export const ADD_LOCAL_STORED_BETS = 'ADD_LOCAL_STORED_BETS';



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/constants/actionTypes.js